<template>
  <div>
      <el-dialog
        title="请到以下平台操作"
        :visible.sync="dialogVisible2"
        width="760px"
        :before-close="no">
        <div class="imgShow">
          <div class="i1">
            <img src="/static/index/index19.png" alt="">
            <div>工程师e家APP</div>
          </div>
          <div>
            <img src="/static/index/index18.png" alt="">
            <div>工程师e家小程序</div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ValidCode',
  data () {
    return {
        dialogVisible2:false
    }
  },
  mounted () {
  },
  methods: {
      click(){
          this.dialogVisible2=true
      },
    no(){
        this.dialogVisible2=false
    }
  }
}
</script>

<style scoped lang="scss">
.imgShow{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 293px;
  border-top: 1px solid #CCCCCC;
  &>div{
    
    img{
      width: 168px;
      height: 168px;
      margin: 0 auto 16px;
    }
    div{
      font-size: 18upx;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
  }
  .i1{
    margin-right: 129px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/show.vue